import {Directive, HostListener} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
	selector: '[userratevalidator]',
	standalone: false
})
export class UserRateValidatorDirective {
	private readonly el: NgControl;

	constructor(private readonly ngControl: NgControl) {
		this.el = ngControl;
	}

	@HostListener('input', ['$event.target.value'])
	onInput(value: string) {
			this.el.control.patchValue(value.replace(/[^0-9%.]/g, ''));
	}
}
